const ADD_RECEPTION_DAYS = "ADD_RECEPTION_DAYS";
const ADD_RECEPTION = "ADD_RECEPTION";
const ADD_RECEPTION_VALIDATION = "ADD_RECEPTION_VALIDATION";
const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";
const ADD_NOTIFICATION = "ADD_NOTIFICATION";
const MANAGE_NOTIFICATION = "MANAGE_NOTIFICATION";
const EDIT_RECEPTION = "EDIT_RECEPTION";
const ADD_OTHER = "ADD_OTHER";
const ADD_VALIDATION_PICTURE = "ADD_VALIDATION_PICTURE";
const REMOVE_VALIDATION_PICTURE = "REMOVE_VALIDATION_PICTURE";
const SET_SELECTED_NOTIFICATION = "SET_SELECTED_NOTIFICATION";
const SET_SELECTED_RECEPTION = "SET_SELECTED_RECEPTION";
const CLEAN_RECEPTION = "CLEAN_RECEPTION";
const EDIT_SELECTED_RECEPTION = "EDIT_SELECTED_RECEPTION";
const DELETE_RECEPTION = "DELETE_RECEPTION";
const SET_RECEPTION_START_SLOT = "SET_RECEPTION_START_SLOT";
const SET_RECEPTION_END_SLOT = "SET_RECEPTION_END_SLOT";

export {
    ADD_RECEPTION_DAYS,
    ADD_RECEPTION,
    ADD_RECEPTION_VALIDATION,
    ADD_NOTIFICATIONS,
    ADD_NOTIFICATION,
    MANAGE_NOTIFICATION,
    EDIT_RECEPTION,
    ADD_OTHER,
    ADD_VALIDATION_PICTURE,
    REMOVE_VALIDATION_PICTURE,
    SET_SELECTED_NOTIFICATION,
    SET_SELECTED_RECEPTION,
    CLEAN_RECEPTION,
    EDIT_SELECTED_RECEPTION,
    DELETE_RECEPTION,
    SET_RECEPTION_START_SLOT,
    SET_RECEPTION_END_SLOT,
};
